import { render, staticRenderFns } from "./BookingDiscount.vue?vue&type=template&id=8d1b8688&scoped=true&"
import script from "./BookingDiscount.vue?vue&type=script&lang=js&"
export * from "./BookingDiscount.vue?vue&type=script&lang=js&"
import style0 from "./BookingDiscount.vue?vue&type=style&index=0&id=8d1b8688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d1b8688",
  null
  
)

export default component.exports